/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon16Light = forwardRef('ArrowRoundTimeBackIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 1.253a.5.5 0 0 0-1 0V5.5a.5.5 0 0 0 .5.5h4a.5.5 0 1 0 0-1H2.6a5.5 5.5 0 1 1-.286 4.333.5.5 0 0 0-.943.333A6.5 6.5 0 1 0 2 4.036V1.253Z" })));
});
